import { render, staticRenderFns } from "./expiry-card.vue?vue&type=template&id=3f3a2888"
import script from "./expiry-card.vue?vue&type=script&lang=js"
export * from "./expiry-card.vue?vue&type=script&lang=js"
import style0 from "./expiry-card.vue?vue&type=style&index=0&id=3f3a2888&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports